import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Box, Text, Image, Button, Spinner } from "@chakra-ui/react";

const AfspraakOverzicht = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get("session_id");

  const [loading, setLoading] = useState(true);
  const [appointmentInfo, setAppointmentInfo] = useState(null);

  useEffect(() => {
    if (sessionId) {
      const info = localStorage.getItem("lastAppointmentInfo");
      if (info) {
        setAppointmentInfo(JSON.parse(info));
      }
    }

    setLoading(false);
  }, [sessionId]);

  if (loading) {
    return (
      <Box mt="100px" textAlign="center">
        <Spinner />
      </Box>
    );
  }

  if (!sessionId || !appointmentInfo) {
    return (
      <Box mt="100px" textAlign="center">
        <Text>Er is iets misgegaan. Probeer opnieuw.</Text>
        <Button mt={4} onClick={() => navigate("/")}>Terug naar home</Button>
      </Box>
    );
  }

  return (
    <Box maxW="600px" mx="auto" mt="100px" p={5} boxShadow="lg" borderRadius="md" bg="white" textAlign="center">
      <Text fontSize="3xl" fontWeight="bold" mb={4}>Afspraak is ingepland</Text>
      <Text fontSize="lg" mb={6}>
        Uw afspraak voor <strong>{appointmentInfo.treatmentName}</strong> is succesvol geboekt en staat ingepland op <strong>{appointmentInfo.formattedDate} om {appointmentInfo.formattedTime}</strong>.<br />
        Gelieve uw mailbox in de gaten te houden voor eventuele updates (controleer ook de spamfolder).<br />
        We kijken er alvast naar uit om u te verwelkomen.
      </Text>
      <Image src="/images/checkmark.png" alt="Bevestiging" mx="auto" maxW="150px" />
    </Box>
  );
};

export default AfspraakOverzicht;
